import { Phone, CircleCheck as CheckCircle2, ShieldCheck, Star, ArrowRight, Layers, Clock, Lock, Loader as Loader2, CircleCheck as CheckCircle } from 'lucide-react';
import { Link } from "@/components/common/Link";
import { FormProvider, useWvcForm } from "@/integrations/forms/FormProvider";
import { Form, FormField, FormItem, FormLabel, FormControl, FormMessage } from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
const HERO_IMG = {
  desktop: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681701/img/panel-hero-desktop.webp",
  tablet: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681701/img/panel-hero-desktop.webp",
  mobile: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681701/img/panel-hero-desktop.webp"
};
const NAVY = "#081438";
const GOLD = "#F5A623";
const FONT_HEAD = "'Plus Jakarta Sans', system-ui, sans-serif";
const FONT_BODY = "'Manrope', system-ui, sans-serif";
const formFooterItems = [{
  icon: "",
  title: "100% Free",
  description: "No charge"
}, {
  icon: "lightning",
  title: "Fast Response",
  description: "Quick turnaround"
}, {
  icon: "lock",
  title: "Private & Secure",
  description: "Your data is safe"
}];
function HeroQuoteForm() {
  const {
    isSubmitting,
    isSubmitted,
    submitError,
    successMessage,
    handleSubmit,
    resetForm,
    control
  } = useWvcForm();
  if (isSubmitted && !submitError) {
    return <div className="flex flex-col items-center justify-center py-12 text-center animate-in fade-in zoom-in duration-300">
        <div className="w-16 h-16 bg-green-100 rounded-lg flex items-center justify-center mb-4">
          <CheckCircle className="w-10 h-10 text-green-600" />
        </div>
        <h3 className="text-2xl font-bold text-[#081438] mb-2">Request Received!</h3>
        <p className="text-slate-600 mb-6">{successMessage || "We'll text you a fixed price within 15 minutes."}</p>
        <Button onClick={resetForm} variant="outline" className="border-[#F5A623] text-[#081438] hover:bg-[#F5A623]/10">
          Send Another Request
        </Button>
      </div>;
  }
  return <Form onSubmit={handleSubmit}>
      <div className="space-y-4">
        <FormField control={control} name="name" rules={{
        required: "Name is required"
      }} render={({
        field
      }) => <FormItem>
              <FormLabel className="text-[#081438] font-semibold">Full Name</FormLabel>
              <FormControl>
                <Input placeholder="Enter your name" {...field} className="bg-slate-50 border-slate-200 focus:border-[#F5A623] focus:ring-[#F5A623]/20" />
              </FormControl>
              <FormMessage />
            </FormItem>} />

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <FormField control={control} name="phone" rules={{
          required: "Phone is required"
        }} render={({
          field
        }) => <FormItem>
                <FormLabel className="text-[#081438] font-semibold">Phone Number</FormLabel>
                <FormControl>
                  <Input type="tel" placeholder="0400 000 000" {...field} className="bg-slate-50 border-slate-200 focus:border-[#F5A623] focus:ring-[#F5A623]/20" />
                </FormControl>
                <FormMessage />
              </FormItem>} />
          <FormField control={control} name="suburb" rules={{
          required: "Suburb is required"
        }} render={({
          field
        }) => <FormItem>
                <FormLabel className="text-[#081438] font-semibold">Suburb</FormLabel>
                <FormControl>
                  <Input placeholder="e.g. Parramatta" {...field} className="bg-slate-50 border-slate-200 focus:border-[#F5A623] focus:ring-[#F5A623]/20" />
                </FormControl>
                <FormMessage />
              </FormItem>} />
        </div>

        <FormField control={control} name="service" render={({
        field
      }) => <FormItem>
              <FormLabel className="text-[#081438] font-semibold">Service Needed</FormLabel>
              <Select onValueChange={field.onChange} defaultValue={field.value}>
                <FormControl>
                  <SelectTrigger className="bg-slate-50 border-slate-200 focus:border-[#F5A623] focus:ring-[#F5A623]/20">
                    <SelectValue placeholder="Select a service" />
                  </SelectTrigger>
                </FormControl>
                <SelectContent>
                  <SelectItem value="Sectional Door Repair">Sectional Door Repair</SelectItem>
                  <SelectItem value="Panel Replacement">Panel Replacement</SelectItem>
                  <SelectItem value="Spring Replacement">Spring Replacement</SelectItem>
                  <SelectItem value="Motor Repair/Install">Motor Repair/Install</SelectItem>
                  <SelectItem value="General Service">General Service</SelectItem>
                </SelectContent>
              </Select>
              <FormMessage />
            </FormItem>} />

        {submitError && <div className="p-3 bg-red-50 border border-red-200 rounded-lg text-red-600 text-sm">
            {submitError}
          </div>}

        <Button type="submit" disabled={isSubmitting} className="w-full bg-[#F5A623] hover:bg-[#D4A63A] text-[#081438] font-bold py-6 text-lg shadow-lg shadow-[#F5A623]/20 transition-all active:scale-[0.98]">
          {isSubmitting ? <>
              <Loader2 className="mr-2 h-5 w-5 animate-spin" />
              Processing...
            </> : "Get My Free Quote"}
        </Button>
      </div>
    </Form>;
}
export default function SectionalHero() {
  return <section className="relative isolate overflow-hidden !bg-[url(https://goldgaragedoor.com.au/wp-content/uploads/2026/06/PHOTO-2026-06-23-10-44-32.webp)] !bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681701/img/image4-hero-mobile.png)] !bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681701/img/image4-hero-tablet.png)] !bg-[url(https://goldgaragedoor.com.au/wp-content/uploads/2026/06/IMG_7174-scaled.jpg)] !bg-[url(https://goldgaragedoor.com.au/wp-content/uploads/2026/06/98e6b5da-5f28-4e7a-9644-2bf8351ab70d-3.webp)]" style={{
    background: NAVY,
    minHeight: "100vh",
    paddingTop: "120px",
    paddingBottom: "80px",
    fontFamily: FONT_BODY
  }}>
      <picture>
        <source media="(max-width: 640px)" srcSet={HERO_IMG.mobile} />
        <source media="(max-width: 1024px)" srcSet={HERO_IMG.tablet} />
        <img src={HERO_IMG.desktop} alt="" aria-hidden="true" loading="eager" decoding="async" style={{
        position: "absolute",
        inset: 0,
        width: "100%",
        height: "100%",
        objectFit: "cover",
        opacity: 0.35,
        zIndex: 0
      }} />
      </picture>

      <div style={{
      position: "absolute",
      inset: 0,
      background: `linear-gradient(135deg, ${NAVY} 0%, rgba(8,20,56,0.85) 50%, rgba(8,20,56,0.95) 100%)`,
      zIndex: 1
    }} />

      <div style={{
      position: "absolute",
      inset: 0,
      opacity: 0.04,
      mixBlendMode: "overlay",
      zIndex: 2,
      backgroundImage: "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='100' height='100'%3E%3Cfilter id='n'%3E%3CfeTurbulence baseFrequency='0.9'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)' opacity='0.5'/%3E%3C/svg%3E\")",
      pointerEvents: "none"
    }} />

      <div style={{
      position: "absolute",
      top: 120,
      left: 0,
      width: 4,
      height: 80,
      background: GOLD,
      zIndex: 3
    }} />

      <div style={{
      position: "relative",
      zIndex: 4,
      maxWidth: 1280,
      margin: "0 auto",
      padding: "0 24px",
      display: "grid",
      gridTemplateColumns: "minmax(0, 1.1fr) minmax(0, 0.9fr)",
      gap: 56,
      alignItems: "center"
    }} className="sectional-hero-grid">
        <div>
          <div style={{
          display: "inline-flex",
          alignItems: "center",
          gap: 10,
          padding: "8px 16px",
          background: "rgba(245,166,35,0.1)",
          border: "1px solid rgba(245,166,35,0.3)",
          borderRadius: 100,
          marginBottom: 28
        }}>
            <Layers size={14} color={GOLD} strokeWidth={2.5} />
            <span style={{
            fontFamily: FONT_BODY,
            fontSize: 12,
            fontWeight: 700,
            letterSpacing: "0.15em",
            textTransform: "uppercase",
            color: GOLD
          }}>
              Sectional Door Specialists · Sydney
            </span>
          </div>

          <h1 style={{
          fontFamily: FONT_HEAD,
          fontSize: "clamp(36px, 5.5vw, 64px)",
          fontWeight: 800,
          color: "#ffffff",
          lineHeight: 1.02,
          letterSpacing: "-0.025em",
          margin: "0 0 24px"
        }}>
            Sectional Door
            <br />
            <span style={{
            background: `linear-gradient(135deg, ${GOLD} 0%, #D4A63A 100%)`,
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
            backgroundClip: "text",
            display: "inline-block",
            fontStyle: "italic"
          }}>
              Panels, Tracks & Hinges
            </span>{" "}
            — fixed today.
          </h1>

          <p style={{
          fontFamily: FONT_BODY,
          fontSize: "clamp(16px, 1.4vw, 19px)",
          color: "rgba(255,255,255,0.78)",
          lineHeight: 1.6,
          maxWidth: 560,
          margin: "0 0 36px"
        }}>
            Sectional doors have more moving parts than any other style —
            panels, hinges, rollers, tracks, springs. We're factory-trained on
            B&D, Steel-Line, and Centurion sectional systems. Same-day repairs
            across Sydney.
          </p>

          <div style={{
          display: "flex",
          flexWrap: "wrap",
          gap: 24,
          marginBottom: 40
        }}>
            {[{
            Icon: Star,
            text: "5.0  Google rated"
          }, {
            Icon: ShieldCheck,
            text: "Licensed & insured"
          }, {
            Icon: CheckCircle2,
            text: "Same-day service"
          }].map(({
            Icon,
            text
          }, i) => <div key={i} style={{
            display: "flex",
            alignItems: "center",
            gap: 8,
            color: "rgba(255,255,255,0.85)",
            fontSize: 14,
            fontWeight: 500,
            fontFamily: FONT_BODY
          }}>
              <Icon size={18} color={GOLD} strokeWidth={2} />
              {text}
            </div>)}
          </div>

          <div style={{
          display: "flex",
          flexWrap: "wrap",
          gap: 14
        }}>
            <Link to="tel:0485000933" style={{
            display: "inline-flex",
            alignItems: "center",
            gap: 10,
            padding: "16px 28px",
            background: GOLD,
            color: NAVY,
            fontFamily: FONT_HEAD,
            fontSize: 16,
            fontWeight: 700,
            borderRadius: 12,
            textDecoration: "none",
            transition: "transform 0.2s, box-shadow 0.2s",
            boxShadow: "0 8px 24px rgba(245,166,35,0.3)"
          }} onMouseEnter={e => {
            e.currentTarget.style.transform = "translateY(-2px)";
            e.currentTarget.style.boxShadow = "0 12px 32px rgba(245,166,35,0.45)";
          }} onMouseLeave={e => {
            e.currentTarget.style.transform = "translateY(0)";
            e.currentTarget.style.boxShadow = "0 8px 24px rgba(245,166,35,0.3)";
          }}>
              <Phone size={18} strokeWidth={2.5} />
              0485 000 933
            </Link>
            <Link to="#contact-us" style={{
            display: "inline-flex",
            alignItems: "center",
            gap: 10,
            padding: "16px 28px",
            background: "transparent",
            color: "#ffffff",
            fontFamily: FONT_HEAD,
            fontSize: 16,
            fontWeight: 600,
            borderRadius: 12,
            textDecoration: "none",
            border: "1px solid rgba(255,255,255,0.25)",
            transition: "background 0.2s, border-color 0.2s"
          }} onMouseEnter={e => {
            (e.currentTarget as HTMLAnchorElement).style.background = "rgba(255,255,255,0.08)";
            (e.currentTarget as HTMLAnchorElement).style.borderColor = "rgba(255,255,255,0.4)";
          }} onMouseLeave={e => {
            (e.currentTarget as HTMLAnchorElement).style.background = "transparent";
            (e.currentTarget as HTMLAnchorElement).style.borderColor = "rgba(255,255,255,0.25)";
          }}>
              Get Free Quote
              <ArrowRight size={16} strokeWidth={2.5} />
            </Link>
          </div>
        </div>

        <FormProvider id="contact-us" formId="hero_quote_form" sectionName="SectionalHero" className="scroll-mt-28" defaultValues={{
        name: "",
        phone: "",
        suburb: "",
        service: "Sectional Door Repair"
      }}>
          <Card className="bg-white border-[#F5A623]/40 shadow-2xl shadow-[#081438]/10 p-6 md:p-8 rounded-lg relative overflow-hidden">
            <div className="absolute top-0 left-0 right-0 h-1.5 bg-gradient-to-r from-[#F5A623] to-[#D4A63A]" />

            <div className="flex items-center gap-2.5 mb-2">
              <span className="w-6 h-px bg-[#F5A623]" />
              <span className="font-bold text-[11px] tracking-[0.2em] uppercase text-[#F5A623]">
                Free quote · No obligation
              </span>
            </div>

            <h2 className="font-bold text-2xl md:text-3xl text-[#081438] leading-tight mb-2 tracking-tight">
              Get Your Free Quote
            </h2>
            <p className="text-sm text-slate-500 mb-6">
              Fast response · No obligation · No hidden fees
            </p>

            <HeroQuoteForm />

            <div className="mt-8 pt-6 border-t border-slate-100 flex flex-wrap justify-between gap-4">
              {formFooterItems.map((item, i) => <div key={i} data-index={i} className="flex items-center gap-2">
                  <div className="w-8 h-8 rounded-lg bg-slate-50 flex items-center justify-center">
                    {item.icon === "" ? <CheckCircle2 size={14} className="text-[#F5A623]" /> : item.icon === "lightning" ? <Clock size={14} className="text-[#F5A623]" /> : <Lock size={14} className="text-[#F5A623]" />}
                  </div>
                  <div>
                    <p className="text-[10px] font-bold text-[#081438] uppercase tracking-wider leading-none mb-0.5">
                      {item.title}
                    </p>
                    <p className="text-[9px] text-slate-400 leading-none">
                      {item.description}
                    </p>
                  </div>
                </div>)}
            </div>
          </Card>
        </FormProvider>
      </div>

      <style>{`
        @media (max-width: 960px) {
          .sectional-hero-grid {
            grid-template-columns: 1fr !important;
            gap: 40px !important;
          }
        }
      `}</style>
    </section>;
}